module.exports = __webpack_public_path__ + "static/media/ccontact.95553db5.png";